var _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmedOrderKpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 36.6104V40.9992C33 42.0601 32.5786 43.0775 31.8284 43.8277C31.0783 44.5778 30.0609 44.9992 29 44.9992H5C3.93913 44.9992 2.92172 44.5778 2.17157 43.8277C1.42143 43.0775 1 42.0601 1 40.9992V36.6104H33Z",
    fill: "#6BE3A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9.0061H29C30.0609 9.0061 31.0783 9.42753 31.8284 10.1777C32.5786 10.9278 33 11.9452 33 13.0061V41.0061C33 42.067 32.5786 43.0844 31.8284 43.8345C31.0783 44.5847 30.0609 45.0061 29 45.0061H5C3.93913 45.0061 2.92172 44.5847 2.17157 43.8345C1.42143 43.0844 1 42.067 1 41.0061V13.0061C1 11.9452 1.42143 10.9278 2.17157 10.1777C2.92172 9.42753 3.93913 9.0061 5 9.0061H9",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.0022H11C9.89543 5.0022 9 5.89763 9 7.0022V11.0022C9 12.1068 9.89543 13.0022 11 13.0022H23C24.1046 13.0022 25 12.1068 25 11.0022V7.0022C25 5.89763 24.1046 5.0022 23 5.0022Z",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7344 26.7376L16.1344 29.3302L21.201 24.6636",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.002,
    cy: 26.9978,
    r: 7,
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedOrderKpi);
export default __webpack_public_path__ + "static/media/Confirmed_orderKPI.4471e8665676806b187ea43d6a1201b5.svg";
export { ForwardRef as ReactComponent };